import { render, staticRenderFns } from "./dialog-hosipitalizationBeds.vue?vue&type=template&id=dd418608"
import script from "./dialog-hosipitalizationBeds.vue?vue&type=script&lang=js"
export * from "./dialog-hosipitalizationBeds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports